import { render, staticRenderFns } from "./ProjectThumbnailCard.vue?vue&type=template&id=704a897d&scoped=true"
import script from "./ProjectThumbnailCard.vue?vue&type=script&lang=js"
export * from "./ProjectThumbnailCard.vue?vue&type=script&lang=js"
import style0 from "./ProjectThumbnailCard.vue?vue&type=style&index=0&id=704a897d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704a897d",
  null
  
)

export default component.exports